module.exports = __webpack_public_path__ + "static/media/ico003.cb57cf8d.png";